import { Navigation } from "../components/navigation";
import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { Image } from "../components/image";
import { Link } from "react-router-dom";
import { Contact } from "../components/contact";


const initialState = {
    name: "",
    email: "",
    message: "",
};
export const ICMS = (props) => {


    const [sildPreView, setSildPreView] = React.useState(5);
    React.useEffect(() => {

        function handleResize() {
            if (window.innerWidth < 768) {
                setSildPreView(1);
            } else if (window.innerWidth < 1024) {
                setSildPreView(2);
            } else {
                setSildPreView(5);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const [{ name, email, message }, setState] = useState(initialState);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({ ...prevState, [name]: value }));
    };
    const clearState = () => setState({ ...initialState });


    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(name, email, message);

        {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }

        emailjs
            .sendForm("OutlookMessage", "template_ogu5p5h", e.target, "pPh3oADNFGfeyKorv")
            .then(
                (result) => {
                    console.log(result.text);
                    clearState();
                },
                (error) => {
                    console.log(error.text);
                }
            );
    };
    return (
        <>
            <div id="post" className="text-center">
                <Navigation />
                <div className="container">
                  
                    <div className="post-items">
                  <img src="img/portfolio/icms.png" alt="" className="img-item" />
<div className="text-item">
                      
                      
                        <p><strong>O que é o Laudo Elétrico de ICMS?</strong></p>
                        <br />
                        <br />
                        <p className="text-justify">O Laudo Elétrico de ICMS é um documento técnico que atesta a regularidade das instalações elétricas de uma empresa, com o objetivo de garantir a segurança dos colaboradores e a conformidade com as normas vigentes. Ele é exigido pela Receita Federal para a obtenção de benefícios fiscais relacionados ao ICMS (Imposto sobre Circulação de Mercadorias e Serviços).</p>
                        <p className="text-justify">O Laudo Elétrico de ICMS é elaborado por um engenheiro eletricista, que realiza uma vistoria minuciosa nas instalações elétricas da empresa, verificando se estão de acordo com as normas técnicas e de segurança estabelecidas pela ABNT (Associação Brasileira de Normas Técnicas) e pelo Corpo de Bombeiros.</p>
                        <p className="text-justify">Além disso, o Laudo Elétrico de ICMS também avalia a eficiência energética das instalações elétricas, identificando possíveis falhas que possam comprometer o desempenho e a segurança do sistema elétrico da empresa.</p>

                        <h1>Como é feito o Laudo Elétrico de ICMS?</h1>
                        <br />
                        <br />
                        <p className="text-justify">
                            Para emissão do laudo técnico é realizada inspeção nas instalações elétricas do cliente, onde é inspecionada e avaliada toda a instalação elétrica da empresa, realizando medições, inspeção visual e levantamento de cargas elétricas.
                            <br />
                            <br />
                            Após esse levantamento, no Laudo Elétrico de ICMS é apontado o percentual de consumo das áreas produtivas (passível de crédito ICMS) e áreas não produtivas (não passível o crédito).
                        </p>
                        <h1>O que é crédito ICMS?</h1>
                        <br />
                        <br />
                        <p className="text-justify"> O crédito de ICMS é um benefício fiscal concedido às empresas que possuem atividade industrial, comercial ou prestadora de serviços, que possuem faturamento de energia elétrica, que permite a redução do valor do imposto a ser pago ao estado.</p>
                        <br />
                        <br />
                        <p className="text-justify">O crédito de ICMS é calculado com base no consumo de energia elétrica da empresa, sendo que o valor do crédito varia de acordo com a atividade da empresa e o percentual de consumo das áreas produtivas e não produtivas.</p>
                        <br />
                        <br />

                        <h1>Quais empresas possuem direito ao crédito de ICMS referente a fatura de energia elétrica?</h1>
                        <br />
                        <br />
                        <p className="text-justify">
                            Todas as empresas que possuem atividade industrial, comercial ou prestadora de serviços, que possuem faturamento de energia elétrica, podem solicitar o crédito de ICMS.
                            <br />
                            <br />
                            A legislação do ICMS prevê que as empresas que possuem atividade industrial, comercial ou prestadora de serviços, podem solicitar o crédito de ICMS referente a fatura de energia elétrica.
                        </p>

                        <h1> Onde possou solicitar o Laudo Elétrico de ICMS?</h1>
                        <br />
                        <p className="text-justify">A Fortesol Energia é uma empresa especializada na elaboração de Laudo Elétrico de ICMS, que conta com uma equipe de engenheiros eletricistas altamente qualificados e experientes, que realizam uma vistoria minuciosa nas instalações elétricas da empresa, garantindo a segurança dos colaboradores e a conformidade com as normas vigentes.</p>

                        <br />
                        <br />
                        <p><strong><i style={{color:'yellow'}} className="fa fa-warning"/>&nbsp;Contrate empresas registradas no CREA!</strong></p>
                        <br />
                        </div>
                        <div className="row orde1 ">
              <div className="col-xs-12 col-md-6 post-text-pro">
              <h1>Faça seu orçamento com a <strong className="forte">FORTE</strong><strong className="sol">SOL</strong></h1>
                        <p>Estamos prontos para atender as suas necessidades</p>
                        <Link
                            to="/budget"
                            className="btn-pulsando btn btn-custom btn-lg page-scroll"
                        >
                            orçamento
                        </Link>{" "}
              </div>
              <div className="col-xs-12 col-md-6">

                <img src="img/orcamento.png" alt="" className="post-img-pro" />
              </div>
            </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <div className="row">


<div className="portfolio-items ">
    <div className="carrosel">

        <Swiper
            autoplay={{ delay: 2500 }}
            slidesPerView={sildPreView}
            navigation
            pagination={{ clickable: true }}

        >
            {props.data
                ? props.data.services.map((d, i) => (
                    <SwiperSlide key={i} >
                        <Image
                            title={d.title}
                            link={d.link}
                            smallImage={d.smallImage}
                        />
                    </SwiperSlide>
                ))
                : "Loading..."
            }
        </Swiper>
    </div>
</div>
</div>

                </div>
                <Link
                    target="_blank"
                    to="https://api.whatsapp.com/send?phone=55854141-4900&text=Olá, gostaria de mais informações sobre os serviços da Fortesol"
                    className="btn btn-wapp  btn-lg page-scroll"

                >
                    <i className="fa fa-whatsapp"></i>
                </Link>{" "}
            </div>




  <Contact />

        </>
    );
};

